import { inject, Injectable } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Injectable({
  providedIn: 'root',
})
export class ToastersService {
  private readonly notification = inject(NzNotificationService);

  showSuccessMessage(message: string, title = '', duration = 3000): void {
    this.notification.success(title, message, {
      nzDuration: duration,
      nzClass: 'ant-notification-notice-success',
      nzStyle: {
        color: 'var(--ant-success-color)',
        border: '1px solid var(--ant-success-color)',
        borderRadius: '5px',
        backgroundColor: 'var(--ant-success-background)',
      },
      nzPlacement: 'bottomRight',
    });
  }

  showErrorMessage(message: string, title = '', duration = 5000): void {
    this.notification.error(title, message, {
      nzDuration: duration,
      nzClass: 'ant-notification-notice-error',
      nzStyle: {
        color: 'var(--ant-error-color)',
        border: '1px solid var(--ant-error-color)',
        borderRadius: '5px',
        backgroundColor: 'var(--ant-error-background)',
      },
      nzPlacement: 'bottomRight',
    });
  }

  showWarningMessage(message: string, title = '', duration = 4000): void {
    this.notification.warning(title, message, {
      nzDuration: duration,
      nzClass: 'ant-notification-notice-warning',
      nzStyle: {
        color: 'var(--ant-warning-color)',
        border: '1px solid var(--ant-warning-color)',
        borderRadius: '5px',
        backgroundColor: 'var(--ant-warning-background)',
      },
      nzPlacement: 'bottomRight',
    });
  }

  showInfoMessage(message: string, title = '', duration = 4000): void {
    this.notification.info(title, message, {
      nzDuration: duration,
      nzClass: 'ant-notification-notice-info',
      nzStyle: {
        color: 'var(--ant-info-color)',
        border: '1px solid var(--ant-info-color)',
        borderRadius: '5px',
        backgroundColor: 'var(--ant-info-background)',
      },
      nzPlacement: 'bottomRight',
    });
  }
}
